
import React from "react";
import ReactSelect from "react-select";
import PropTypes from "prop-types";
import { getSelectStyles } from "./selectStyles";

const SearchableSelect = ({
  label,
  name,
  value,
  required = false,
  className = "",
  placeholder = "Select...",
  options = [],
  onChangeHandler,
  error,
  disabled = false,
  // aria-invalid and inputId for accessibility
  inputId,
  ariaInvalid,
}) => {
  const formattedOptions = options.map((o) => ({
    value: o.id,
    label: o.name
  }));

  const selectedValue = formattedOptions.find((x) => x.value === value) || null;

  return (
    <div className="form-group">
      {label && (
        <label htmlFor={inputId || name} className="mb-1 mt-1 text-capitalize fw-semibold">
          {label}
          {required && <i className="text-danger ms-1">*</i>}
        </label>
      )}

      <ReactSelect
        className={className}
        isDisabled={disabled}
        options={formattedOptions}
        value={selectedValue}
        placeholder={placeholder}
        inputId={inputId || name}
        name={name}
        styles={getSelectStyles({ invalid: Boolean(error) })}
        aria-invalid={ariaInvalid}
        onChange={(selected) => {
          const fakeEvent = {
            target: {
              name,
              value: selected ? selected.value : "",
            },
          };
          onChangeHandler(fakeEvent);
        }}
      />

      {error && <div className="invalid-feedback d-block mt-1">{error}</div>}
    </div>
  );
};

SearchableSelect.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  required: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.array,
  onChangeHandler: PropTypes.func.isRequired,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  inputId: PropTypes.string,
  ariaInvalid: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string
  ]),
};

export default SearchableSelect;
